
const toggleSpMenu = () => {
    const btn = document.getElementsByClassName('js-hamburger-btn');

    if(!btn || btn.length === 0) return;

    const body = document.body;

    [...btn].forEach(elem => {
        elem.addEventListener('click', () => {
            body.classList.toggle('is-sp-nav-open');
        });
    })
}
toggleSpMenu();

const closeSpMenu = () => {
    const bg = document.getElementsByClassName('js-close-sp-nav');

    if(!bg || bg.length === 0) return;

    const body = document.body;

    [...bg].forEach(elem => {
        elem.addEventListener('click', () => {
            body.classList.remove('is-sp-nav-open');
        })
    })

    
}
closeSpMenu();

const toggleSearchOverlay = () => {
    const btn = document.getElementsByClassName('js-search-btn');

    if(!btn || btn.length === 0) return;

    const body = document.body;

    [...btn].forEach(elem => {
        elem.addEventListener('click', () => {
            body.classList.toggle('is-search-overlay-open');
        });
    });
    
}
toggleSearchOverlay();

const closeSearchOverlay = () => {
    const closeBtns = document.getElementsByClassName('js-close-search-overlay');

    if(!closeBtns || closeBtns.length === 0) return;

    const body = document.body;

    [...closeBtns].forEach(btn => {
        btn.addEventListener('click', () => {
            body.classList.remove('is-search-overlay-open');
        })
    })

    
}
closeSearchOverlay();


const showFixedHeader = () => {

    const header = document.querySelector('.l-header--fixed.l-header--transparent');

    if (!header) return;
    
    const trigger = document.getElementById('js-viewport-height-trigger');
  
    if (!trigger) return;
  
    const observer = new IntersectionObserver((entries) => {
        for (const e of entries) {
            if (e.isIntersecting) {
                header.classList.remove('is-show');
            } else {
                header.classList.add('is-show');
            }
        }
        }, {});
        observer.observe(trigger);
    }
showFixedHeader();